import { Link, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentFailedPage = () => {
  const [params] = useSearchParams();
  const orderRef = params.get('ordernumber') || params.get('order_ref') || params.get('orderNumber') || '';
  return (
    <div className="container-pd py-16 max-w-lg" data-testid="payment-failed-page">
      <div className="font-mono text-[10px] text-[color:var(--pd-gold)] uppercase tracking-[0.2em]">Payment</div>
      <div className="mt-6 rounded-2xl border border-[color:var(--pd-danger)]/50 bg-[color:var(--pd-danger)]/10 p-6">
        <div className="flex items-start gap-3">
          <XCircle size={26} className="text-[color:var(--pd-danger)] shrink-0" />
          <div>
            <div className="font-display text-3xl leading-tight">Payment didn&rsquo;t go through.</div>
            <p className="text-sm text-muted-sage mt-2">Your card wasn&rsquo;t charged. No tickets have been issued.</p>
            <p className="text-xs text-muted-sage mt-3">
              Try again below, or if this keeps happening, contact us at <a href="mailto:hello@thepadeldraw.co.uk" className="text-[color:var(--pd-accent-yellow)] underline">hello@thepadeldraw.co.uk</a>{orderRef ? <> and quote reference <span className="font-mono">{orderRef}</span></> : null}.
            </p>
          </div>
        </div>
        <div className="mt-5 flex flex-wrap gap-2">
          <Link to="/competitions" className="bg-[color:var(--pd-accent-yellow)] text-[#14251c] px-4 py-2.5 rounded-xl text-sm font-medium">Try again</Link>
          <Link to="/account" className="border border-[color:var(--pd-accent-yellow)] text-[color:var(--pd-accent-yellow)] px-4 py-2.5 rounded-xl text-sm font-medium">My account</Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailedPage;
